import { Box, Grid, Heading, Text } from "@chakra-ui/react"
import { SkeletonData, linear } from '../SkeletonData/SkeletonData.js';
import { useNavigate } from "react-router-dom";

export const SkeletonPage = () => {
    const navigate = useNavigate()


    return (
        <Box w={'100%'} h={'100vh'} overflow={'scroll'} bg={linear}>

            <Box>
                <Box display={'flex'} gap={'10px'} p={'10px'}>
                    <Text color={'#00C853'} fontSize={'30px'} fontWeight={'bold'}>|| </Text>
                    <Text color={'white'} fontSize={'30px'} fontWeight={'bold'}>Skeleton</Text>
                </Box>

                <Box textAlign={'center'} color={'white'} p={'1cm 0'} m={'.5cm auto'}>
                    <Heading>Simplify Web Development with</Heading>
                    <Box display={'flex'} gap={'7px'} w={'fit-content'} m={'auto'}>
                        <Heading m={'10px auto'} fontSize={'25px'}>Our Free Loading</Heading>
                        <Heading m={'10px auto'} color={'#00E676'} fontSize={'25px'}>Skeletons</Heading>
                    </Box>
                </Box>

            </Box>

            <Box bg={'#212121'} borderRadius={'20px 20px 0 0'} p={'0.5cm 0'}>
                <Grid w={'95%'} m={'1cm auto'} templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} gap={['20px']}>
                    {SkeletonData && SkeletonData.length != 0 && SkeletonData?.map((ele, index) => (
                        <Box onClick={() => navigate(`Card/${ele.id}`)} bg={'white'} key={index} cursor={'pointer'} borderRadius={'10px'} boxShadow={'transparent 0px 7px 29px 0px'}>
                            <style>
                                {ele.CSS}
                            </style>
                            {/* <Text>{index}</Text> */}
                            <Box display={'flex'} justifyContent={'center'} justifyItems={'center'}
                                key={index}
                                dangerouslySetInnerHTML={{ __html: ele.HTML }} />
                        </Box>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}